import { es, enUS, type Locale } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

/**
 * Returns the date-fns Locale and BCP 47 locale string for the current i18n language.
 * Use for `date-fns` formatting and for native `Intl` APIs.
 */
export function useDateLocale(): { locale: Locale; localeString: string } {
  const { i18n } = useTranslation('common');

  switch (i18n.language) {
    case 'es':
      return { locale: es, localeString: 'es-ES' };
    case 'en':
    default:
      return { locale: enUS, localeString: 'en-US' };
  }
}
